import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Generated class for the SafeHtmlPipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  constructor(private sanitized: DomSanitizer) {}
  transform(value,type?) {
    if(type == 'url')
    return this.sanitized.bypassSecurityTrustUrl(value);
    else if(type == 'style')
    return this.sanitized.bypassSecurityTrustStyle(value);
    else if(type == 'iframe')
    return this.sanitized.bypassSecurityTrustResourceUrl(value);
    else
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/safe-html/safe-html.ts